module.exports = __webpack_public_path__ + "img/GazelEnergie_80X30.2eedca11.png";